import { type NonZeroVector, vector } from '../../../elements/index';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/index';
import {
  PI_RADIANS_45,
  PI_RADIANS_135,
  PI_RADIANS_225,
  PI_RADIANS_315,
} from '../../../utils/angles';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createCircleNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;
const INNER_ARROW_POSITION = 6.8;
const OUTER_ARROW_POSITION = 18;

function createVgwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const diagonalBottomRight = vector.unit(PI_RADIANS_45);
  const diagonalBottomLeft = vector.unit(PI_RADIANS_135);
  const diagonalTopLeft = vector.unit(PI_RADIANS_225);
  const diagonalTopRight = vector.unit(PI_RADIANS_315);

  const getVgwArrowSvg = (
    direction: NonZeroVector,
    start: number,
    end: number,
  ) =>
    makeTag('path', {
      d: getArrowSvgPath({
        from: vector.mult(direction, start),
        to: vector.mult(direction, end),
        headWidth: 8.8,
        headHeight: 4.4,
        tailWidth: 2.8,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawCircleBackground(DIAMETER / 2, opts.style)}
    ${getVgwArrowSvg(diagonalTopLeft, OUTER_ARROW_POSITION, INNER_ARROW_POSITION)}
    ${getVgwArrowSvg(diagonalTopRight, INNER_ARROW_POSITION, OUTER_ARROW_POSITION)}
    ${getVgwArrowSvg(diagonalBottomRight, OUTER_ARROW_POSITION, INNER_ARROW_POSITION)}
    ${getVgwArrowSvg(diagonalBottomLeft, INNER_ARROW_POSITION, OUTER_ARROW_POSITION)}
    ${makeTag('path', {
      d: new SvgPathBuilder()
        .moveTo(0, 3.6)
        .lineTo(-2.4, -3.6)
        .hLineTo(-4.8)
        .lineTo(-1.2, 6)
        .hLineTo(1.2)
        .lineTo(4.8, -3.6)
        .hLineTo(2.4)
        .buildClosed(),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    })}
  `;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const vgwIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createVgwIcon,
);
